import { set } from 'lodash/fp';
import { handleActions } from 'redux-actions';
import {
  showConfirmDeleteReportTemplate,
  hideConfirmDeleteReportTemplate
} from '../../../actions';

const initialState = {
  showDeleteModal: false
};

export default handleActions(
  {
    [showConfirmDeleteReportTemplate]: set('showDeleteModal', true),
    [hideConfirmDeleteReportTemplate]: set('showDeleteModal', false)
  },
  initialState
);
